import BaseApi from "../../../services/baseApi";

class ExcelFile_se {
    constructor() {
        this.entity = 'smsExcel';
    }


    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/'+this.entity+'/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    save(file , template) {
        let formData = new FormData();
        formData.set("file",file)
        formData.set("id", template)
        // formData.set("template", template)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/sendForExcel/',
            headers: {'Content-Type': 'application/json'},
        })
    }




}
export default new ExcelFile_se();
